import { AxiosResponse } from 'axios'
import { clamp, cloneDeep, set } from 'lodash-es'
import { actionTree, getterTree, mutationTree } from 'typed-vuex'
import { sortByDate } from '~/lib/utils/mailboxSortAndFilter'
import { setState } from '~/lib/utils/store'

export const INBOX = 'INBOX'
export const SENT = 'SENT'

export type MailType = 'INBOX' | 'SENT'

const markAsReadInProgress = []

export const state = () => ({
  mailState: null,
  currentMail: null,
  [INBOX]: null,
  [SENT]: null,
  metaData: null
})

export const getters = getterTree(
  state,
  {
    stateMails(state) {
      return state.mailState && state[state.mailState]
    },
    mails(state, getters, { list }) {
      return list.mailbox.result
        ? list.mailbox.result
        : state[state.mailState]
    }
  }
)
export const mutations = mutationTree(
  state, {
    setState,
    changeMailProp(state, { mail, propName, propVal }) {
      mail[propName] = propVal
    }
  }
)

export const actions = actionTree(
  { state, getters, mutations }, {
    setMails({ state, commit }, type: MailType): Promise<void | AxiosResponse<any, any>> {
      commit('setState', { stateName: 'mailState', data: type })
      if (state[type] !== null && state[type].length) {
        commit('setState', {
          stateName: 'currentMail',
          data: state[state.mailState][0]
        })

        return new Promise<void>((resolve) => {
          resolve()
        })
      }
      return this.$api.mailbox.index({
        type: type.toLowerCase(),
        accountId: this.$auth.user.id
      })
        .then((response: Axios.AxiosResponse) => {
          if (response.status === 200 && response.data.data) {
            let convertedDecoratedMailList = response.data.data

            convertedDecoratedMailList =
              sortByDate(convertedDecoratedMailList, true)

            commit('setState', {
              stateName: type,
              data: convertedDecoratedMailList
            })

            if (!convertedDecoratedMailList.length) { return }

            commit('setState', {
              stateName: 'currentMail',
              data: state[state.mailState]?.[0]
            })
          }
          return response
        })
    },
    markAsRead({ state, commit }, mail): void {
      if (typeof mail === 'undefined' || mail === null) {
        return
      }

      commit('setState', {
        stateName: 'currentMail',
        data: mail
      })

      const currentMails = state[state.mailState]
      const isUpdating = markAsReadInProgress.includes(mail.id)

      if (currentMails === null || !currentMails.length || mail.isRead || isUpdating) { return }

      markAsReadInProgress.push(mail.id)

      this.$api.mailbox.update({
        emailId: mail.id,
        accountId: this.$auth.user.id
      }, {
        data: {
          attributes: {
            isRead: true
          }
        }
      })
        .then((response) => {
          markAsReadInProgress.splice(markAsReadInProgress.indexOf(mail.id), 1)
          if (response.status === 200 && response.data.data) {
            const { read, unread } = this.app.$auth.user.meta.mailbox.inbox
            const newUnreadCount = clamp(unread - 1, 0, Infinity)
            const newReadCount = read + 1
            const updatedUser = cloneDeep(this.app.$auth.user)
            set(updatedUser, 'meta.mailbox.inbox.unread', newUnreadCount)
            set(updatedUser, 'meta.mailbox.inbox.read', newReadCount)
            this.$auth.setUser(updatedUser)
            commit('changeMailProp', { mail, propName: 'isRead', propVal: true })
          }
        })
    },
    /**
     * @deprecated
     */
    mailBoxMetaData({ commit, rootState: { auth } }) {
      return this.$api.mailbox.metaData({ id: auth.user.id }).then((response) => {
        if (response.status === 200 && response.data.data) {
          commit('setState', {
            stateName: 'metaData',
            data: response.data.data.meta
          })
        }
      })
    }
  }
)
